import {Component, Output, EventEmitter, OnInit} from '@angular/core';
import {GLOBAL} from '../../shared/global';

@Component({
    selector: 'app-booking-filter',
    templateUrl: './booking-filter.component.html',
    styleUrls: ['./booking-filter.component.css']
})
export class BookingFilterComponent implements OnInit {

    extRefNumber: string;
    @Output() appBookingFilter = new EventEmitter();

    ngOnInit() {
      this.extRefNumber = GLOBAL.isExternalReferenceSearchValueExists() ? GLOBAL.getExternalReferenceSearchValue() : '';
      GLOBAL.setExternalReferenceSearchValue(this.extRefNumber);
    }

    clear() {
        this.extRefNumber = '';
        this.filter();
    }

    filter() {
      if ( GLOBAL.getExternalReferenceSearchValue() !== this.extRefNumber) {
        GLOBAL.setExternalReferenceSearchValue(this.extRefNumber);
        this.appBookingFilter.emit();
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-filter/booking-filter.component.ts